import { COMPANIES } from 'constants/Entities';
import BASE_CONFIG from 'containers/companies/EntityConfig';
import { getMarketingStatusColumn } from 'components/TableCells/MarketingStatusCell/column';
import { setMarketingConsentAccount } from 'services/MarketingConsentService';

const ALLOWED_COLS = ['name', 'responsible', 'companytype', 'email1'];

export default ({ onClickCheckbox, spamchimp, canEdit } = {}) => {
    const tableParams = {
        ...(onClickCheckbox ? { account: { onClickCheckbox } } : {}),
        spamchimp,
        ...(canEdit !== undefined ? { canEdit } : {}),
    };
    const base = BASE_CONFIG(tableParams);
    const filterKey = spamchimp ? 'subscribersCompanies_v2' : 'subscribersCompanies';
    const quickFilters = spamchimp
        ? ['marketingStatus', ...base.quickFilters.filter((id) => id !== 'marketingStatus')]
        : base.quickFilters.filter((id) => id !== 'marketingStatus');

    const marketingColumn = spamchimp
        ? [
              getMarketingStatusColumn({
                  minWidth: 160,
                  entity: COMPANIES,
                  setMarketingConsent: setMarketingConsentAccount,
              }),
          ]
        : [];

    return {
        ...base,
        filterKey,
        quickFilters,
        columnSelectorSections: undefined,
        withEntitySelection: true,
        selectionFor: COMPANIES.entity,
        isLocalSelection: true,
        columnDefs: [
            ...base.columnDefs
                .filter((col) => ALLOWED_COLS.includes(col.colId))
                .map(({ width, suppressSizeToFit, ...col }) => ({ ...col, minWidth: width })),
            ...marketingColumn,
        ],
    };
};
